/* PortraPet ART (26/10/2026): cuộn mượt (Lenis, chỉ máy có chuột), hiện dần khi cuộn, header trong suốt/ẩn khi cuộn xuống,
   parallax ảnh, hộp chọn style, FAQ mở mượt, PDP: giá trong nút mua + nội dung dưới thành tab, số khối cho team (chỉ bản xem trước).
   Không đụng logic giỏ hàng. 26/10 chiều: bỏ panel style xếp chồng (trang quá dài). */
(function () {
  'use strict';
  var d = document, w = window, root = d.documentElement;
  w.__artReady = true;
  var reduce = w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = w.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var lenis = null, parallax = [], hdrSec = null, lastY = 0, pad = false;
  /* 27/10 tốc độ: lenis nằm trong assets, chỉ tải khi cần (màn ≥ 768px + chuột) */
  var lenisSrc = d.currentScript && d.currentScript.getAttribute('data-lenis');
  /* 27/10 tốc độ: Swiper mặc định tải trước mọi ảnh slider (gallery PDP ~50 ảnh); để ảnh loading="lazy" tự tải khi tới gần/khi vuốt */
  try { w.MinimogLibs.Swiper.extendDefaults({ preloadImages: false }); } catch (e) {}

  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  /* 1. Cuộn mượt */
  function initLenis() {
    if (reduce || !fine || w.innerWidth < 768) return;
    if (!w.Lenis) {
      if (lenisSrc) { var s = d.createElement('script'); s.src = lenisSrc; s.onload = initLenis; lenisSrc = ''; d.head.appendChild(s); }
      return;
    }
    try {
      lenis = new w.Lenis({
        duration: 1.1,
        easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
        smoothWheel: true,
        /* 29/10: trackpad tự cuộn mượt trên luồng riêng của trình duyệt; Lenis kéo việc cuộn về JS nên trang bận là giật → chỉ làm mượt con lăn chuột (wheelDelta bội số 120). Gặp trackpad 1 lần thì để trình duyệt cuộn cả phiên */
        virtualScroll: function (e) { var ev = e.event; if (ev.type === 'wheel' && ev.deltaMode === 0 && ev.wheelDeltaY % 120) pad = true; return !pad || ev.type !== 'wheel'; },
        prevent: function (n) { return !!(n && n.closest && n.closest('[data-lenis-prevent],dialog,select,textarea,.m-cart-drawer,.m-drawer,.m-search-popup,.pswp,.jdgm-modal,[class*=drawer],[class*=modal],[class*=popup]')); }
      });
    } catch (e) { lenis = null; return; }
    (function raf(t) { lenis.raf(t); requestAnimationFrame(raf); })(performance.now());
    var lock = function () {
      var cls = (root.className + ' ' + d.body.className).replace(/lenis[\w-]*/g, '');
      var locked = getComputedStyle(d.body).overflowY === 'hidden' || /overflow-hidden|no-scroll|scroll-lock/.test(cls);
      if (locked) lenis.stop(); else if (!d.querySelector('dialog[open]')) lenis.start();
    };
    new MutationObserver(lock).observe(d.body, { attributes: true, attributeFilter: ['class', 'style'] });
    d.addEventListener('click', function (e) {
      if (e.defaultPrevented) return;
      var a = e.target.closest && e.target.closest('a[href^="#"]');
      if (!a || a.hasAttribute('data-art-choose')) return;
      var id = a.getAttribute('href');
      if (id.length < 2) return;
      var t = d.getElementById(id.slice(1));
      if (!t) return;
      e.preventDefault();
      lenis.scrollTo(t, { offset: -((hdrSec && hdrSec.offsetHeight) || 0) });
    });
  }

  /* 2. Chữ tách từng chữ để trồi lên */
  function split(el) {
    if (el.getAttribute('data-art-done')) return;
    el.setAttribute('data-art-done', '1');
    var i = 0;
    (function walk(node) {
      each(Array.prototype.slice.call(node.childNodes), function (n) {
        if (n.nodeType === 3) {
          var parts = n.textContent.split(/(\s+)/), frag = d.createDocumentFragment();
          parts.forEach(function (p) {
            if (!p) return;
            if (/^\s+$/.test(p)) { frag.appendChild(d.createTextNode(' ')); return; }
            var o = d.createElement('span'), inner = d.createElement('span');
            o.className = 'art-w'; inner.textContent = p; inner.style.setProperty('--wi', i++);
            o.appendChild(inner); frag.appendChild(o);
          });
          n.parentNode.replaceChild(frag, n);
        } else if (n.nodeType === 1 && n.tagName !== 'BR') { walk(n); }
      });
    })(el);
  }

  /* 3. Hiện dần khi cuộn tới */
  function initReveal() {
    each(d.querySelectorAll('[data-art-split]'), split);
    var els = d.querySelectorAll('[data-art-reveal],[data-art-split],[data-art-img]');
    if (reduce || !('IntersectionObserver' in w)) { each(els, function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -9% 0px', threshold: 0 });
    var vh = w.innerHeight;
    each(els, function (e) { var r = e.getBoundingClientRect(); if (r.top < vh && r.bottom > 0) e.classList.add('is-in'); else io.observe(e); });
  }

  /* 4. Header */
  function initHeader() {
    var hdr = d.querySelector('.pps-header');
    if (!hdr) return;
    hdrSec = hdr.closest('.shopify-section') || hdr;
    hdrSec.classList.add('art-hdr');
    if (d.querySelector('[data-art-hero]')) d.body.classList.add('art-home-hero');
    var setH = function () { root.style.setProperty('--art-hdr-h', hdr.offsetHeight + 'px'); };
    setH(); w.addEventListener('resize', setH);
    var btn = hdr.querySelector('[data-pps-menu]');
    if (btn) new MutationObserver(function () {
      d.body.classList.toggle('art-menu-open', btn.getAttribute('aria-expanded') === 'true');
    }).observe(btn, { attributes: true, attributeFilter: ['aria-expanded'] });
    hdr.addEventListener('toggle', function () {
      d.body.classList.toggle('art-menu-open', !!hdr.querySelector('details[open]') || (btn && btn.getAttribute('aria-expanded') === 'true'));
    }, true);
  }
  function updateHeader(y) {
    if (!hdrSec) return;
    d.body.classList.toggle('art-scrolled', y > 24);
    var busy = d.body.classList.contains('art-menu-open');
    if (!busy && y > lastY + 6 && y > 360) hdrSec.classList.add('is-hidden');
    else if (y < lastY - 6 || y < 160 || busy) hdrSec.classList.remove('is-hidden');
  }

  /* 5. Parallax ảnh (chỉ màn rộng) */
  function initMotion() {
    if (reduce) return;
    parallax = Array.prototype.slice.call(d.querySelectorAll('[data-art-speed]'));
  }
  function updateMotion() {
    var vh = w.innerHeight, wide = w.innerWidth >= 750;
    if (wide) parallax.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) return;
      var c = r.top + r.height / 2 - vh / 2;
      el.style.transform = 'translate3d(0,' + (c * parseFloat(el.getAttribute('data-art-speed'))).toFixed(1) + 'px,0)';
    });
  }

  /* 27/10: Minimog (collection.js) lấy mốc dính thanh Filter theo offsetTop tương đối nên trên mobile thanh dính đầu màn hình ngay khi cuộn khối studio C01. Chỉ cho dính khi đã tới lưới SP */
  var gridSec = null;
  function updateToolbar() { if (gridSec) root.classList.toggle('art-tb-wait', gridSec.getBoundingClientRect().top > 0); }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var y = w.scrollY || w.pageYOffset;
      updateHeader(y); updateMotion(); updateToolbar();
      lastY = y; ticking = false;
    });
  }

  /* 6. Hộp chọn style */
  function initChooser() {
    var dlg = d.querySelector('[data-art-chooser]');
    if (!dlg || typeof dlg.showModal !== 'function') return;
    d.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-art-choose]');
      if (!t) return;
      e.preventDefault();
      dlg.showModal();
      if (lenis) lenis.stop();
    });
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg || (e.target.closest && e.target.closest('[data-art-close]'))) dlg.close();
    });
    dlg.addEventListener('close', function () { if (lenis) lenis.start(); });
  }

  /* 7. FAQ mở/đóng mượt */
  function initFaq() {
    each(d.querySelectorAll('.art-faq details'), function (dt) {
      var s = dt.querySelector('summary'), a = dt.querySelector('.art-faq__a');
      if (!s || !a) return;
      s.addEventListener('click', function (e) {
        if (reduce) return;
        e.preventDefault();
        var done = function (fn) { var h = function (ev) { if (ev.target !== a) return; a.removeEventListener('transitionend', h); fn(); }; a.addEventListener('transitionend', h); };
        if (dt.open) {
          a.style.height = a.scrollHeight + 'px';
          requestAnimationFrame(function () { a.style.height = '0px'; });
          done(function () { dt.open = false; a.style.height = ''; });
        } else {
          dt.open = true;
          var h = a.scrollHeight;
          a.style.height = '0px';
          requestAnimationFrame(function () { requestAnimationFrame(function () { a.style.height = h + 'px'; }); });
          done(function () { a.style.height = ''; });
        }
      });
    });
  }

  /* 8. Trang sản phẩm */
  function initPdp() {
    if (!d.body.classList.contains('template-product')) return;
    var btn = d.querySelector('.main-product__block-buy_buttons .m-add-to-cart');
    var priceBox = d.querySelector('.main-product__block-price .m-price');
    if (btn && priceBox) {
      var tag = d.createElement('span');
      tag.className = 'art-atc-price';
      btn.appendChild(tag);
      var readPrice = function () {
        var items = priceBox.querySelectorAll('.m-price-item--last, .m-price-item--sale, .m-price-item--regular');
        var txt = '';
        each(items, function (it) { if (!txt && it.offsetParent !== null && /\d/.test(it.textContent)) txt = it.textContent.trim(); });
        if (!txt) { var m = priceBox.textContent.match(/[$€£]\s?[\d.,]+/); txt = m ? m[0] : ''; }
        tag.textContent = txt ? txt : '';
        tag.style.display = txt ? '' : 'none';
      };
      readPrice();
      new MutationObserver(readPrice).observe(priceBox, { childList: true, subtree: true, characterData: true, attributes: true });
    }
    each(d.querySelectorAll('[id*="__studio_content"] .section, [id*="__studio_content"] section.pps, .pp-trust, .pp-acc'), function (s) { s.setAttribute('data-art-reveal', ''); });
    /* 27/10 Most Loved: chỉ hiện khi biến thể đang chọn là Framed Poster 11x14 / 16x20 */
    /* 28/10 QA: SP Teeinblue không dùng variant-picker → nghe thêm teeinblue-event-variant-changed; so theo id biến thể (Liquid ghi sẵn) */
    var ml = d.querySelector('[data-pp-most-loved]');
    if (ml) {
      var mlIds = ml.getAttribute('data-pp-most-loved').split(',');
      var mlSet = function (id) { ml.hidden = !id || mlIds.indexOf(String(id)) < 0; };
      d.addEventListener('change', function (e) {
        var picker = e.target.closest && e.target.closest('variant-picker');
        if (picker) setTimeout(function () { mlSet(picker.currentVariant && picker.currentVariant.id); });
      });
      d.addEventListener('teeinblue-event-variant-changed', function (e) { mlSet(e.detail && e.detail.variantId); });
    }
  }

  /* 8b. PDP: 9 khối nội dung dưới gom vào 4 tab (data-art-tab trong pp-studio-product-content). Link #portrait-... ở chỗ khác vẫn mở đúng tab */
  function initTabs() {
    var nav = d.querySelector('.pps-pdp-nav'), panes = d.querySelectorAll('[data-art-tab]');
    if (!nav || !panes.length) return;
    var has = function (id) { return !!id && !!d.querySelector('[data-art-tab="' + id + '"]'); };
    var links = Array.prototype.filter.call(nav.querySelectorAll('a[href^="#"]'), function (a) {
      if (!has(a.hash.slice(1))) { a.hidden = true; return false; }
      a.setAttribute('role', 'tab');
      return true;
    });
    if (!links.length) return;
    nav.setAttribute('role', 'tablist');
    var show = function (id) {
      each(panes, function (p) { p.hidden = p.getAttribute('data-art-tab') !== id; });
      links.forEach(function (a) { a.setAttribute('aria-selected', a.hash.slice(1) === id ? 'true' : 'false'); });
      if (lenis) lenis.resize();
    };
    var start = location.hash.slice(1);
    show(has(start) ? start : links[0].hash.slice(1));
    d.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href^="#"]');
      if (!a || !has(a.hash.slice(1))) return;
      show(a.hash.slice(1));
      if (nav.contains(a)) e.preventDefault();
    });
    d.addEventListener('shopify:block:select', function (e) {
      var p = e.target.closest && e.target.closest('[data-art-tab]');
      if (p) show(p.getAttribute('data-art-tab'));
    });
  }

  /* 9. Số khối để team gọi tên (H = trang chủ, P = sản phẩm, C = danh mục). Chỉ hiện trên theme chưa publish hoặc trong Customize */
  function initSeg() {
    var S = w.Shopify || {};
    if (!S.designMode && !(S.theme && S.theme.role && S.theme.role !== 'main')) return;
    var m = d.body.className.match(/\btemplate-(\w+)/);
    var pre = { index: 'H', product: 'P', collection: 'C' }[m && m[1]] || 'S';
    var tag = function (el, txt, sub) {
      var b = d.createElement('span');
      b.className = 'art-seg' + (sub ? ' art-seg--sub' : '');
      b.setAttribute('aria-hidden', 'true');
      b.textContent = txt;
      el.appendChild(b);
    };
    root.classList.add('art-seg-on');
    each(d.querySelectorAll('main .shopify-section'), function (s, i) {
      var no = pre + (i < 9 ? '0' : '') + (i + 1);
      tag(s, no + ' · ' + (s.id.split('__')[1] || s.id).replace(/_/g, ' '));
      each(s.querySelectorAll('[data-art-tab],[data-art-seg]'), function (p, j) { tag(p, no + '.' + (j + 1), true); });
    });
  }

  /* 10. 29/10: hàng cuộn ngang (mobile): trackpad lướt chéo bị Chrome khoá vào hàng ngang → trang không xuống, hàng snap về chỗ cũ = kẹt. Lượt lăn chủ yếu dọc thì cuộn trang */
  function initRows() {
    each(d.querySelectorAll('.art-styles__stack,.art-gallery__grid,.art-moments__row,.studio-format-grid'), function (el) {
      el.style.overscrollBehaviorX = 'contain'; /* tới mép hàng: lượt lăn không chuyền sang trang (tránh cuộn đôi) và không kích hoạt vuốt lùi trang của Mac */
      el.addEventListener('wheel', function (e) {
        if (e.ctrlKey || Math.abs(e.deltaY) <= Math.abs(e.deltaX) || el.scrollWidth <= el.clientWidth + 1) return;
        e.preventDefault();
        w.scrollBy({ top: e.deltaMode === 1 ? e.deltaY * 16 : e.deltaY, behavior: 'instant' });
      }, { passive: false });
    });
  }

  function init() {
    root.classList.add('art-ready');
    var tb = d.querySelector('.m-collection-toolbar'); gridSec = tb && tb.closest('.shopify-section');
    initHeader(); initPdp(); initTabs(); initSeg(); initReveal(); initMotion(); initChooser(); initFaq(); initRows(); initLenis();
    w.addEventListener('scroll', onScroll, { passive: true });
    w.addEventListener('resize', onScroll);
    onScroll();
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
